import React from "react";

import {
	CustomerRelatedPersonProps,
	CustomerRelatedPersonState
} from "./models";

import { Document, PersonType } from "../../../../pages/models";
import PersonForm from "../../../person-form/person-form";

import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Button,
	IconButton,
	Stack,
	Tooltip,
	Typography
} from "@mui/material";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PersonIcon from "@mui/icons-material/Person";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import DescriptionIcon from "@mui/icons-material/Description";
import { t, Trans } from "@lingui/macro";

export default class CustomerRelatedPerson extends React.Component<CustomerRelatedPersonProps, CustomerRelatedPersonState>
{
	private onDelete = () => {
		if(this.props.onDelete) {
			this.props.onDelete(this.props.person);
		}
	};

	private onDeleteDocument = (document: Document) => {
		if(this.props.onRequestDeleteDocument) {
			this.props.onRequestDeleteDocument(document, this.props.person);
		}
	};

	private triggerUploadDocument = () => {
		if(this.props.onUploadDocument) {
			this.props.onUploadDocument(this.props.person);
		}
	};

	private onDeleteIconClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		event.preventDefault();
		event.stopPropagation();
		this.onDelete();
	};

	private onUploadDocumentIconClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		event.preventDefault();
		event.stopPropagation();
		this.triggerUploadDocument();
	};

	render()
	{
		const deleteLabel = t({ id: "crp-delete", message: "Elimina persona" });
		const uploadLabel = t({ id: "crp-upload-person-document", message: "Carica documenti" });
		const hasDocuments = (this.props.person.documentList?.length ?? 0) > 0;
		const documentStatusLabel = hasDocuments
			? t({ id: "crp-person-documents-present", message: "Documenti associati presenti" })
			: t({ id: "crp-person-documents-missing", message: "Documenti associati mancanti" });
		const documentIconLabel = this.props.onUploadDocument ? uploadLabel : documentStatusLabel;

		return (<> <Accordion id={"we" + Math.random()} sx={{mt: 1}}>
			<AccordionSummary
				expandIcon={<ExpandMoreIcon />}
				aria-controls="panel1a-content"
				id="panel1a-header">
				<Stack direction="row" alignItems="center" justifyContent="space-between" sx={{width: "100%"}}>
					<Stack direction="row" alignItems="center" flexWrap="wrap">
						<PersonIcon sx={{mr: 2}} />
						{this.props.person.name} {this.props.person.surname} - {this.props.person.type === PersonType.EXECUTOR &&
						<Typography sx={{
							fontWeight: "bold",
							ml: 1
						}}>
							<Trans id={"crp-executor"}>
								Esecutore
							</Trans>
						</Typography>}
						{this.props.person.type === PersonType.OWNER && <Typography
							sx={{
								fontWeight: "bold",
								ml: 1
							}}>
							<Trans id={"crp-owner"}>
								Titolare
							</Trans>
						</Typography>}
					</Stack>
					<Stack direction="row" alignItems="center" spacing={1}>
						<Tooltip title={documentStatusLabel}>
							<IconButton
								size="small"
								onClick={this.onUploadDocumentIconClick}
								aria-label={documentIconLabel}>
								<DescriptionIcon
									fontSize="small"
									sx={{ color: hasDocuments ? "success.main" : "warning.main" }}
								/>
							</IconButton>
						</Tooltip>
						{this.props.canDelete && this.props.onDelete && <IconButton
							size="small"
							color="error"
							onClick={this.onDeleteIconClick}
							title={deleteLabel}
							aria-label={deleteLabel}>
							<DeleteOutlineIcon fontSize="small" />
						</IconButton>}
					</Stack>
				</Stack>
			</AccordionSummary>
			<AccordionDetails>
				<PersonForm
					person={this.props.person}
					readOnly={true}
					canDeleteDocuments={this.props.canDeleteDocuments}
					onRequestDeleteDocument={this.props.onRequestDeleteDocument ? this.onDeleteDocument : undefined}
				/>
				{this.props.canDelete && this.props.onDelete && <Stack direction="row" justifyContent="flex-end" sx={{mt: 2}}>
					<Button
						variant="outlined"
						color="error"
						onClick={this.onDelete}
						size="small">
						<Trans id="crp-delete">Elimina persona</Trans>
					</Button>
				</Stack>}
			</AccordionDetails>
		</Accordion>
		</>);
	}
}
